<template>
    <el-dialog :title="$t('Create Role')" :visible.sync="dialogFormVisible" :before-close="handleClose">
        <el-form :label-position="labelPosition" :model="roleForm" :rules="rules" ref="roleForm" class="demo-roleForm">
            <el-form-item :label="$t('Role name')" prop="name">
                <el-input v-model="roleForm.name"></el-input>
            </el-form-item>
            <el-form-item :label="$t('Select Parent')" prop="parent_id">
                <el-select v-model="roleForm.parent_id" :placeholder="$t('Select Parent')" clearable>
                    <el-option v-for="item in parent_roles" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('Status')" prop="status">
                <el-switch v-model="roleForm.status" active-color="#13ce66" inactive-color="#ff4949" active-value="active"
                    inactive-value="inactive">
                </el-switch>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="resetForm('roleForm')">{{ $t('Cancel') }}</el-button>
            <el-button type="primary" @click="submitForm('roleForm')">{{ $t('Save') }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
    export default {
        props: {
            dialogFormVisible: Boolean
        },
        data() {
            return {
                parent_roles: [],
                roleForm: {
                    name: '',
                    parent_id: '',
                    status: 'active'
                },
                labelPosition: "top",
                rules: {
                    name: [{
                        required: true,
                        message: this.$t('Role name is required'),
                        trigger: "blur"
                    }]
                }
            };
        },
        mounted() {
            request({
                url: "get-all-roles",
                method: "get"
            }).then(response => {
                this.parent_roles = response.data.data;
                this.$emit('parentRoles', this.parent_roles)
            });
        },
        methods: {
            handleClose() {
                this.$emit('popup', false)
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.$emit('popup', false)
            },
            submitForm(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        this.$parent.fullscreenLoading = true;
                        request({
                                url: "roles",
                                method: "post",
                                data: this.roleForm
                            })
                            .then(response => {
                                this.$parent.fullscreenLoading = false;
                                this.$notify({
                                    title: this.$t('Success'),
                                    message: response.data.message,
                                    type: "success",
                                    offset: 50
                                });
                                this.$emit('popupsave', false);
                                this.handleClose();
                            })
                            .catch(error => {
                                this.$parent.fullscreenLoading = false;
                                this.$notify({
                                    title: this.$t('Error'),
                                    message: error.response.data.message,
                                    type: "error",
                                    offset: 50
                                });
                            });
                    }
                });
            }
        }
    };

</script>



// WEBPACK FOOTER //
// src/components/Layout/Role/CreateRole.vue